// Locale-aware, numeric-aware, case-insensitive string comparator for option lists.
// German locale (the UI is German); numeric:true so 'Item 2' < 'Item 10'; sensitivity:'base'
// so case/accents don't split otherwise-equal labels (ä≈a, A≈a).
const collator = new Intl.Collator('de', { numeric: true, sensitivity: 'base' })

export function compareLabel(a: string, b: string): number {
  return collator.compare(a, b)
}
